import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

import { useXcelAccess } from '@/features/xcel-prelicensing';

interface XcelPrelicensingRouteProps {
  children: ReactNode;
}

/**
 * Route guard for the XCEL prelicensing admin page.
 *
 * `/api/xcel-prelicensing/my-access/` decides who may open it (any of
 * `xcel_prelicensing:view|review|manage`, granted per person in the access
 * console). Others go to /home. The backend enforces every endpoint independently.
 */
export function XcelPrelicensingRoute({ children }: XcelPrelicensingRouteProps) {
  const { data, isLoading, isError } = useXcelAccess();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (isError || !(data?.view || data?.review || data?.manage)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
